import { render, staticRenderFns } from "./pasters.vue?vue&type=template&id=fee6f42c"
import script from "./pasters.vue?vue&type=script&lang=js"
export * from "./pasters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports